// One to five stars, picked. Radio buttons under the stars, so the keyboard works as it does on
// any radio group - Tab to it, arrows to move - and a screen reader hears "4 stars, 4 of 5".

import { STARS } from './ratings.js';

export default function StarPicker({ value, onChange, disabled }) {
  return (
    <fieldset className="star-picker" disabled={disabled}>
      <legend>Stars</legend>
      {STARS.map((stars) => (
        <label key={stars} className={stars <= value ? 'lit' : undefined}>
          <input type="radio" name="stars" value={stars} checked={value === stars}
                 onChange={() => onChange(stars)} />
          <span aria-hidden="true">★</span>
          <span className="visually-hidden">{stars} star{stars === 1 ? '' : 's'}</span>
        </label>
      ))}
    </fieldset>
  );
}
